function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.00305 1.24006C1.00305 0.79692 1.36229 0.437685 1.80542 0.437685H11.3193C12.2055 0.437685 12.924 1.15615 12.924 2.04243V9.95152C12.924 10.1414 12.77 10.2954 12.5801 10.2954H1.80542C1.36229 10.2954 1.00305 9.93616 1.00305 9.49302V1.24006Z",
  stroke: "#373D49",
  strokeWidth: 0.687747
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.8608 2.73023C10.8608 2.4137 11.1174 2.1571 11.434 2.1571H13.7838C15.3981 2.1571 16.7067 3.46574 16.7067 5.08003V10.2954C16.7067 10.4854 16.5527 10.6393 16.3628 10.6393H11.2047C11.0148 10.6393 10.8608 10.4854 10.8608 10.2954V2.73023Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8608 2.73023C10.8608 2.4137 11.1174 2.1571 11.434 2.1571H13.7838C15.3981 2.1571 16.7067 3.46574 16.7067 5.08003V10.2954C16.7067 10.4854 16.5527 10.6393 16.3628 10.6393H11.2047C11.0148 10.6393 10.8608 10.4854 10.8608 10.2954V2.73023Z",
  fill: "#E9EDC4",
  stroke: "#373D49",
  strokeWidth: 1.37549,
  mask: "url(#path-2-inside-1)"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 12.4653,
  y: 4.33496,
  width: 4.24111,
  height: 2.52174,
  rx: 0.458498
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 12.4653,
  y: 4.33496,
  width: 4.24111,
  height: 2.52174,
  rx: 0.458498,
  stroke: "#373D49",
  strokeWidth: 1.37549,
  mask: "url(#path-3-inside-2)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.67115,
  cy: 10.41,
  r: 1.26087,
  fill: "#E9EDC4",
  stroke: "#373D49",
  strokeWidth: 0.687747
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.2678,
  cy: 10.41,
  r: 1.26087,
  fill: "#E9EDC4",
  stroke: "#373D49",
  strokeWidth: 0.687747
});

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.344132c6.svg";
export { ForwardRef as ReactComponent };